import React from 'react';
import _ from 'lodash';
import { graphql, withApollo, compose } from 'react-apollo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ClaimWithDocuments } from '../../queries/ClaimWithDocuments';
import mapCPTs from '../../utils/mapCPTs';
import mapConnection from '../../utils/connectionMapper';
import * as messageActions from '../../actions/message-actions';
import { showMessage as showMessageAction } from '../../actions/message-actions';

const initialState = {
  selectedAirRefundDocuments: [],
  selectedCourtDocuments: []
};

const DocumentsContainer = WrappedComponent => {
  return class extends React.Component {
    get taskWithDocumentsValues() {
      const { taskValues } = this.props;
      const taskWithDocumentsData = {
        ...initialState,
        ...taskValues
      };
      return taskWithDocumentsData;
    }

    componentWillReceiveProps(nextProps) {
      const { claim } = nextProps.data;
      const prevDocuments = this.returnDocumnentsInfo().documents;
      const { legalFormalNotice, documents } = this.returnDocumnentsInfo(
        claim
      );
      const {
        defaultSelectedDocumentTypes,
        documentsName,
        setTaskValues,
        taskValues,
        onlyOneDocument,
        taskType
      } = this.props;
      if (
        taskType === 'CA' &&
        !onlyOneDocument &&
        taskValues[documentsName].length === 0 &&
        prevDocuments.length !== documents.length
      ) {
        const comparedElements =
          defaultSelectedDocumentTypes || legalFormalNotice;
        const selectedDocuments = _.filter(documents, obj =>
          _.includes(
            comparedElements,
            obj[defaultSelectedDocumentTypes ? 'type' : 'id']
          )
        );
        setTaskValues({
          [documentsName]: selectedDocuments,
          errorDocuments: this.filterInvalidDocumentIds(selectedDocuments)
        });
      }
    }

    filterInvalidDocumentIds = documents =>
      _.filter(documents, ['valid', false]).map(doc => doc.id);

    setErrorMessage = text =>
      this.props.showMessage({
        text,
        props: { negative: true },
        duration: 2000
      });

    setSelectedStageDocuments = () => {
      const {
        selectedDocuments,
        selectedAirRefundDocuments,
        selectedCourtDocuments
      } = this.taskWithDocumentsValues;
      const { documentsName } = this.props;
      switch (documentsName) {
        case 'selectedAirRefundDocuments':
          return selectedAirRefundDocuments;
        case 'selectedCourtDocuments':
          return selectedCourtDocuments;
        default:
          return selectedDocuments;
      }
    };

    updateSelectedDocuments = (id, type, valid, selectedDocument) => {
      const { setTaskValues, documentsName } = this.props;
      let newDocuments = this.setSelectedStageDocuments();

      if (selectedDocument) {
        newDocuments = _.xorBy(newDocuments, [{ id, type, valid }], 'id');
      } else {
        const updatedDocumentIndex = _.findIndex(newDocuments, ['id', id]);
        newDocuments[updatedDocumentIndex] = { id, type, valid };
      }
      const invalidDocumentIds = this.filterInvalidDocumentIds(newDocuments);
      setTaskValues({
        [documentsName]: newDocuments,
        errorDocuments: invalidDocumentIds
      });
      invalidDocumentIds.length &&
        this.setErrorMessage(`Invalid documents: [${invalidDocumentIds}]`);
    };

    returnDocumnentsInfo = nextClaim => {
      const claim = nextClaim || this.props.data.claim;
      const { selectedPassengers } = this.props;
      const { claimsPassengerTickets, legalFormalNotice } = mapCPTs(claim);
      const selectedClaimsPassengerTickets = selectedPassengers
        ? claimsPassengerTickets.filter(cpt =>
            selectedPassengers.includes(cpt.passengerTicket.id)
          )
        : claimsPassengerTickets;
      const passengers = selectedClaimsPassengerTickets.map(cpt => ({
        passengerTicket: cpt.passengerTicket,
        documents: mapConnection(cpt.documentsConnection)
      }));

      const documents = selectedClaimsPassengerTickets.reduce(
        (prev, curr) => [
          ...prev,
          ...mapConnection(curr.documentsConnection).map(doc => ({
            id: doc.id,
            type: doc.type,
            valid: doc.documentValid
          }))
        ],
        []
      );

      return { passengers, documents, legalFormalNotice };
    };

    setLoadingValue = () => {
      const { onlyOneDocument } = this.props;
      const loading = _.get(this, 'props.data.loading');
      const { passengers } = this.returnDocumnentsInfo();
      let hasDocument;
      if (onlyOneDocument) {
        if (!loading && !_.isEmpty(passengers)) {
          _.forEach(
            passengers,
            passenger => (hasDocument = passenger.documents.length === 0)
          );
        }
      }
      return hasDocument || loading;
    };

    render() {
      const { passengers, documents } = this.returnDocumnentsInfo();
      const selectedDocuments = this.setSelectedStageDocuments();
      const { errorDocuments } = this.taskWithDocumentsValues;
      const refetchClaimWithDocuments = _.get(this, 'props.data.refetch');
      return (
        <WrappedComponent
          {...this.props}
          setErrorMessage={this.setErrorMessage}
          updateSelectedDocuments={this.updateSelectedDocuments}
          passengers={passengers}
          documents={documents}
          selectedDocuments={selectedDocuments}
          errorDocuments={errorDocuments}
          loading={this.setLoadingValue()}
          refetchClaimWithDocuments={refetchClaimWithDocuments}
        >
          {this.props.children}
        </WrappedComponent>
      );
    }
  };
};

const withClaimDocumentsQuery = graphql(ClaimWithDocuments, {
  options: ({ claimId, match, documentType, filterTypes, refetch }) => ({
    variables: {
      id: _.get(match, 'params.id') || claimId,
      filter: {
        types: filterTypes
      }
    },
    pollInterval: refetch
  }),
  notifyOnNetworkStatusChange: true,
  props: ({ data }) => {
    return {
      data
    };
  }
});

const mapDispatchToProps = dispatch => ({
  actions: () => bindActionCreators(messageActions, dispatch),
  showMessage: message => dispatch(showMessageAction(message))
});

export default WrappedComponent =>
  connect(
    null,
    mapDispatchToProps
  )(
    compose(
      withApollo,
      withClaimDocumentsQuery
    )(DocumentsContainer(WrappedComponent))
  );



// WEBPACK FOOTER //
// ./src/component/Documents/withExtendedClaimDocuments.js